import { Form, Row, Col, Card, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import {
  getTipoDoc,
  getTipoPersona,
  getCondIVA,
  getProvincias,
  getBarrios,
  getCalles,
  postContribCrear,
  getCP,
} from "../services/transport.services";
import Swal from "sweetalert2";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationTaxpayer } from "../utils/validation";

export function FormTaxpayer() {
  const [data, setData] = useState(false);
  const [tipoDoc, setTipoDoc] = useState();
  const [condIVA, setCondIVA] = useState();
  const [provincias, setProvincias] = useState();
  const [tipoPersona, setTipoPersona] = useState();
  const [barrios, setBarrios] = useState();
  const [calles, setCalles] = useState();
  const [cp, setCP] = useState({});

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationTaxpayer),
  });

  useEffect(() => {
    if (localStorage.getItem("data")) {
      let dataStorage = localStorage.getItem("data");
      setData(JSON.parse(dataStorage));
    }
  }, []);

  useEffect(() => {
    getTipoDoc().then((res) => setTipoDoc(res.data));
    getTipoPersona().then((res) => setTipoPersona(res.data));
    getCondIVA().then((res) => setCondIVA(res.data));
    getProvincias().then((res) => setProvincias(res.data));
    getBarrios().then((res) => setBarrios(res.data));
    getCalles().then((res) => setCalles(res.data));
  }, []);

  useEffect(() => {
    if (!cp) {
      Swal.fire({
        text: "Código Postal inválido",
        icon: "error",
      });
    } else if (cp && cp.CODIGO_PRO) {
      setProvincias((prev) => {
        return prev.filter((provincia) => provincia.CODIGO === cp.CODIGO_PRO);
      });
    }
  }, [cp]);

  const onsubmit = (value) => {
    const nombreCalle = calles.filter(
      (calle) => calle.CODIGO === value.cod_calle
    );

    value.email = data.email;
    value.cc = data.codigo;
    value.cod_prov = cp.CODIGO_PRO;
    value.cod_loc = cp.COD_LOC;

    value.calle = nombreCalle[0].DESCRIPCION;

    postContribCrear(value).then((res) => {
      if (res.data && res.data.nro_contrib) {
        const dataStorage = localStorage.getItem("data");
        const dataParse = JSON.parse(dataStorage);
        dataParse.idrafam = res.data.nro_contrib;
        localStorage.setItem("data", JSON.stringify(dataParse));
        Swal.fire({
          title: "Exito",
          text: "Se ha registrado como contribuyente de manera exitosa",
          icon: "success",
          willClose: () => window.location.replace("/tramite-transporte"),
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Ocurrió un error al registrarse. Intente nuevamente",
          icon: "error",
          willClose: () => window.location.replace("/nuevo-contribuyente"),
        });
      }
    });
  };

  const handleOnBlur = async (e) => {
    if (e.target.value.trim() === "") return;
    const res = await getCP(e.target.value);
    setCP(res.data[0]);
  };

  return (
    <div className="container mt-5 mb-5 form">
      <Form onSubmit={handleSubmit(onsubmit)}>
        <Card className="shadow mb-5 bg-white rounded">
          <Card.Header className="text-uppercase text-center">
            Inscripción Nuevo Contribuyente
          </Card.Header>
          <Card.Body>
            <Form.Group>
              <Row className="mb-2">
                <Col sm={12} md={6} className="mb-2">
                  <Form.Label className="text-uppercase">
                    Razon social
                  </Form.Label>
                  <Form.Control
                    name="razon_social"
                    placeholder="Apellido y Nombre / Nombre de Empresa"
                    {...register("razon_social")}
                    isInvalid={!!errors.razon_social}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.razon_social?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col sm={12} md={6}>
                  <Form.Label className="text-uppercase">
                    Cuit o Cuil
                  </Form.Label>
                  <Form.Control
                    name="cc"
                    value={data.codigo}
                    disabled
                    {...register("cc")}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">
                    Tipo de Documento
                  </Form.Label>
                  <Form.Control
                    className="text-uppercase"
                    as="select"
                    name="tipo_doc"
                    isInvalid={!!errors.tipo_doc}
                    {...register("tipo_doc")}
                  >
                    {" "}
                    <option disabled selected hidden></option>
                    {tipoDoc &&
                      tipoDoc.map((tipodoc) => (
                        <option value={tipodoc.CODIGO}>
                          {tipodoc.DESCRIPCION}
                        </option>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.tipo_doc?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">
                    nro de documento
                  </Form.Label>
                  <Form.Control
                    name="nro_doc"
                    {...register("nro_doc")}
                    isInvalid={!!errors.nro_doc}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.nro_doc?.message}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col sm={12} md={6} className="mb-2">
                  <Form.Label className="text-uppercase">Email</Form.Label>
                  <Form.Control
                    name="email"
                    disabled
                    value={data.email}
                    {...register("email")}
                  />
                </Col>
                <Col sm={12} md={6}>
                  <Form.Label className="text-uppercase">telefono</Form.Label>
                  <Form.Control
                    name="telefonos"
                    {...register("telefonos")}
                    isInvalid={!!errors.telefonos}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.telefonos?.message}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">
                    Tipo de persona
                  </Form.Label>
                  <Form.Control
                    className="text-uppercase"
                    as="select"
                    name="tp_persona"
                    isInvalid={!!errors.tp_persona}
                    {...register("tp_persona")}
                  >
                    <option disabled selected hidden></option>
                    {tipoPersona &&
                      tipoPersona.map((tipoPersona) => (
                        <option value={tipoPersona.id}>
                          {tipoPersona.name}
                        </option>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.tp_persona?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">
                    condición de IVA
                  </Form.Label>
                  <Form.Control
                    className="text-uppercase"
                    as="select"
                    name="tp_iva"
                    isInvalid={!!errors.tp_iva}
                    {...register("tp_iva")}
                  >
                    <option disabled selected hidden></option>
                    {condIVA &&
                      condIVA.map((condIVA) => (
                        <option value={condIVA.id}>{condIVA.name}</option>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.tp_iva?.message}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">
                    Código Postal
                  </Form.Label>
                  <Controller
                    control={control}
                    name="cp"
                    {...register("cp")}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <Form.Control
                        onBlur={handleOnBlur}
                        onChange={(value) => onChange(value)}
                        value={value}
                        isInvalid={!!errors.cp}
                      />
                    )}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.cp?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">Provincia</Form.Label>
                  <Form.Control
                    className="text-uppercase"
                    as="select"
                    name="cod_prov"
                    disabled
                    {...register("cod_prov")}
                  >
                    {cp.CODIGO_PRO &&
                      provincias &&
                      provincias.map((provincia) => (
                        <option value={provincia.CODIGO}>
                          {provincia.DESCRIPCION}
                        </option>
                      ))}
                  </Form.Control>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">localidad</Form.Label>
                  <Form.Control
                    className="text-uppercase"
                    as="select"
                    name="cod_loc"
                    disabled
                    {...register("cod_loc")}
                  >
                    {cp && <option value={cp.COD_LOC}>{cp.DESCRIPCION}</option>}
                  </Form.Control>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">Barrio</Form.Label>
                  <Form.Control
                    className="text-uppercase"
                    as="select"
                    name="codbarrio"
                    isInvalid={!!errors.codbarrio}
                    {...register("codbarrio")}
                  >
                    <option disabled selected hidden></option>
                    {barrios &&
                      barrios.map((barrio) => (
                        <option value={barrio.CODIGO}>
                          {barrio.DESCRIPCION}
                        </option>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.codbarrio?.message}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">calle</Form.Label>
                  <Form.Control
                    className="text-uppercase"
                    as="select"
                    name="cod_calle"
                    isInvalid={!!errors.cod_calle}
                    {...register("cod_calle")}
                  >
                    <option disabled selected hidden></option>
                    {calles &&
                      calles.map((calle) => (
                        <option value={calle.CODIGO}>
                          {calle.DESCRIPCION}
                        </option>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.cod_calle?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">Altura</Form.Label>
                  <Form.Control
                    name="nro"
                    {...register("nro")}
                    isInvalid={!!errors.nro}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.nro?.message}
                  </Form.Control.Feedback>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">piso</Form.Label>
                  <Form.Control name="piso" {...register("piso")} />
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="text-uppercase">
                    departamento
                  </Form.Label>
                  <Form.Control name="dept" {...register("dept")} />
                </Col>
              </Row>
            </Form.Group>
          </Card.Body>
        </Card>

        <div className="text-center">
          <Button
            type="submit"
            variant="outline-primary"
            className="p-2 pl-4 pr-4"
          >
            REGISTRAR
          </Button>
        </div>
      </Form>
    </div>
  );
}
